const KeyContactsSectionBlk = () => {
  return (
    <div className="use-cases-section-blk">
      <video autoPlay muted loop playsInline>
        <source
          src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/videos/video-background.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
      <div className="use-cases-section-overlay">
        <img
          className="key-contacts-bg"
          src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/key-contacts-bg-image.png"
          alt="Key Contacts Background"
        />
      </div>
      <div className="main-container-blk">
        <h1>Key Contacts</h1>
        <p>
          Connect directly with the people who drive every iCXeed and AWS
          engagement.
        </p>
      </div>
    </div>
  );
};

export default KeyContactsSectionBlk;
